import styles from "./ProductCategoryModal.scss";
import primaryComponents from "../../primaryComponents";
import ProductCategoryModalLogic from "./ProductCategoryModalLogic";
import ProductCategoryModalValidation from "./ProductCategoryModalValidation";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import Icon from "../../../assets/icons";
import { useEffect } from "react";
import { PlusCircle } from "../../../assets/svgIcons";

const ProductCategoryForm = ({
  refetchCategories,
  setIsActive,
  category = [],
  isEdit = false,
}) => {
  const {
    isEditingProductCategories,
    // categoryDescription,
    categoryName,
    existingIds,
    // setCategoryDescripion,
    setCategoryName,
    handleAddCategory,
    subCategories,
    handleAddSubCategory,
    handleDeleteSubCategory,
    handleSubCategoryChange,
    handleUpdateCategory,
    isCreatingProductCategories,
    handleDeleteProductCategory,
  } = ProductCategoryModalLogic({
    setIsActive,
    category,
    refetchCategories,
    isEdit,
  });

  const {
    register,
    formState: { errors },
    trigger,
    control,
    setValue,
    handleSubmit,
  } = ProductCategoryModalValidation({
    categoryName,
    subCategories,
    category,
    isEdit,
  });

  useEffect(() => {
    setValue("allowValidation", subCategories?.length > 0);
  }, [subCategories, setValue]);

  return (
    <form className={`${globalStyles.pageColumnGaps}`}>
      {/* Category name */}
      <primaryComponents.InputFieldV2
        name="categoryName"
        control={control}
        defaultValue={categoryName}
        label={"Category Name"}
        className={"white"}
        isRequired={true}
        placeholder="Enter your category name"
        type="text"
        errorMessage={errors.categoryName}
        onKeyUp={() =>
          errors.categoryName !== undefined && trigger("categoryName")
        }
        onChange={({ target: { value } }) => {
          setCategoryName(value);
        }}
        register={register}
      />
      {subCategories.length > 0 ? (
        <div className={`${globalStyles.cardWithBorder} mt-3`}>
          {subCategories.map((sub, index) => (
            <>
              <div
                key={index}
                className="d-flex align-items-center pt-3"
                style={{ gap: "15px" }}
              >
                <primaryComponents.Button
                  classNames={"btn btn--outline-red smallBtn mb-3"}
                  style={{ width: "12px" }}
                  onClick={() =>
                    sub?.id && existingIds.includes(String(sub.id))
                      ? handleDeleteProductCategory(sub?.id)
                      : handleDeleteSubCategory(index)
                  }
                >
                  <img src={Icon.deleteIcon} alt="" />
                </primaryComponents.Button>
                <primaryComponents.InputFieldV2
                  name={
                    isEdit
                      ? `subCategories.${index}.value`
                      : `subCategories.${index}`
                  }
                  control={control}
                  className="white"
                  placeholder="Enter your sub-category name"
                  type="text"
                  defaultValue={isEdit ? sub.value : sub}
                  value={sub?.value}
                  errorMessage={
                    isEdit
                      ? errors?.subCategories?.[index]?.value
                      : errors?.subCategories?.[index]
                  }
                  onKeyUp={() =>
                    (isEdit
                      ? errors?.subCategories?.[index]?.value
                      : errors?.subCategories?.[index]) !== undefined &&
                    trigger(
                      isEdit
                        ? `subCategories.${index}.value`
                        : `subCategories.${index}`,
                    )
                  }
                  onChange={({ target: { value } }) =>
                    handleSubCategoryChange(sub?.id ?? index, value)
                  }
                  register={register}
                />
              </div>
            </>
          ))}
        </div>
      ) : null}
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ cursor: "pointer" }}
        onClick={handleAddSubCategory}
      >
        <PlusCircle />
        <p className="purple--text ml-1">Add Sub-categories</p>
      </div>

      <div
        className={`${globalStyles.stickyBottomCover} ${styles.stickyBottomCover}`}
      >
        <primaryComponents.Button
          type="button"
          classNames={"btn btn--primary cover"}
          isDisabled={isEditingProductCategories || isCreatingProductCategories}
          isLoading={isEditingProductCategories || isCreatingProductCategories}
          loadingText={isEdit ? "Updating category..." : "Adding category..."}
          onClick={handleSubmit((data) => {
            if (isEdit) {
              handleUpdateCategory(data);
            } else {
              handleAddCategory(data);
            }
          })}
        >
          {isEdit ? "Update product category" : "Add product category"}
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default ProductCategoryForm;
